// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_Free = require("../Control.Monad.Free/index.js");
var Control_Monad_Rec_Class = require("../Control.Monad.Rec.Class/index.js");
var Data_DateTime_Instant = require("../Data.DateTime.Instant/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Filterable = require("../Data.Filterable/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Effect = require("../Effect/index.js");
var FRP_Event = require("../FRP.Event/index.js");
var FRP_Event_Class = require("../FRP.Event.Class/index.js");
var FRP_Event_Time = require("../FRP.Event.Time/index.js");
var Framework_Audio = require("../Framework.Audio/index.js");
var Framework_UI = require("../Framework.UI/index.js");
var stepEngine = function (reset) {
    return function (step) {
        return function (input) {
            return function (v) {
                var go = function (v1) {
                    var v2 = Control_Monad_Free.resume(Framework_UI.functorUIF)(v1.ui);
                    if (v2 instanceof Data_Either.Right) {
                        return new Control_Monad_Rec_Class.Done(reset);
                    };
                    if (v2 instanceof Data_Either.Left && v2.value0 instanceof Framework_UI.UIAction) {
                        var result = step(v1.gs)(v2.value0.value0);
                        return new Control_Monad_Rec_Class.Loop({
                            ui: v2.value0.value1(result),
                            gs: Data_Either.either(Control_Applicative.pure(Control_Applicative.applicativeFn)(v1.gs))(Control_Category.identity(Control_Category.categoryFn))(result),
                            i: v1.i
                        });
                    };
                    if (v2 instanceof Data_Either.Left && v2.value0 instanceof Framework_UI.UIAwaitingInput) {
                        if (v1.i instanceof Data_Maybe.Nothing) {
                            return new Control_Monad_Rec_Class.Done({
                                ui: v1.ui,
                                gs: v1.gs
                            });
                        };
                        if (v1.i instanceof Data_Maybe.Just) {
                            return new Control_Monad_Rec_Class.Loop({
                                ui: v2.value0.value1(v1.i.value0),
                                gs: v1.gs,
                                i: Data_Maybe.Nothing.value
                            });
                        };
                        throw new Error("Failed pattern match at Framework.Engine (line 119, column 14 - line 125, column 27): " + [ v1.i.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at Framework.Engine (line 110, column 7 - line 125, column 27): " + [ v2.constructor.name ]);
                };
                return Control_Monad_Rec_Class.tailRec(go)({
                    ui: v.ui,
                    gs: v.gs,
                    i: new Data_Maybe.Just(input)
                });
            };
        };
    };
};
var makeStrictMono = function (dictOrd) {
    return function (f) {
        return function (e) {
            var mono = function (v) {
                if (v.last instanceof Data_Maybe.Nothing) {
                    return true;
                };
                if (v.last instanceof Data_Maybe.Just) {
                    return Data_Ord.lessThan(dictOrd)(f(v.last.value0))(f(v.now));
                };
                throw new Error("Failed pattern match at Framework.Engine (line 82, column 5 - line 84, column 37): " + [ v.last.constructor.name ]);
            };
            return Data_Functor.map(FRP_Event.functorEvent)(function (v) {
                return v.now;
            })(Data_Filterable.filter(FRP_Event.filterableEvent)(mono)(FRP_Event_Class.withLast(FRP_Event.eventIsEvent)(e)));
        };
    };
};
var runEngine = function (v) {
    return function __do() {
        var v1 = FRP_Event.create();
        var tick = FRP_Event_Time.interval(33);
        var tickWithEngineState = FRP_Event_Class.sampleOn(FRP_Event.eventIsEvent)(v1.event)(Data_Functor.map(FRP_Event.functorEvent)(Data_Function.flip(Data_Function["const"]))(tick));
        var cancelDraw = FRP_Event.subscribe(FRP_Event_Time.withTime(Data_Filterable.filterMap(FRP_Event.filterableEvent)(function (v2) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Framework_UI.getUIState(v2.ui))(function (uis) {
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)({
                    uis: uis,
                    gs: v2.gs
                });
            });
        })(tickWithEngineState)))(function (v2) {
            return v.draw(v2.time)(v2.value.uis)(v2.value.gs)(v.ctx);
        })();
        var getAudioSignal = function (e) {
            var v2 = Framework_UI.getUIState(e.ui);
            if (v2 instanceof Data_Maybe.Nothing) {
                return Framework_Audio.emptyAudioSignal;
            };
            if (v2 instanceof Data_Maybe.Just) {
                return v.getAudio(v2.value0);
            };
            throw new Error("Failed pattern match at Framework.Engine (line 52, column 26 - line 54, column 42): " + [ v2.constructor.name ]);
        };
        var audioStream = Data_Functor.map(FRP_Event.functorEvent)(function (v2) {
            return v2.samples;
        })(makeStrictMono(Data_Maybe.ordMaybe(Data_DateTime_Instant.ordDateTime))(function (v2) {
            return v2.timestamp;
        })(Data_Functor.map(FRP_Event.functorEvent)(getAudioSignal)(v1.event)));
        var cancelAudio = FRP_Event.subscribe(audioStream)(function (audioEvents) {
            return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(audioEvents)(function (v2) {
                return Framework_Audio.playAudio(v2.delay)(v2.audio);
            });
        })();
        var freshEngine = {
            ui: v.ui,
            gs: v.init
        };
        var handleReset = function (v2) {
            if (v2 instanceof Data_Maybe.Nothing) {
                return freshEngine;
            };
            if (v2 instanceof Data_Maybe.Just) {
                return v2.value0;
            };
            throw new Error("Failed pattern match at Framework.Engine (line 64, column 7 - line 64, column 40): " + [ v2.constructor.name ]);
        };
        var cancelEngine = FRP_Event.subscribe(FRP_Event_Class.sampleOn(FRP_Event.eventIsEvent)(v1.event)(Data_Functor.map(FRP_Event.functorEvent)(stepEngine(freshEngine)(v.step))(v.inputs)))(v1.push)();
        v1.push(freshEngine)();
        return function __do() {
            cancelEngine();
            cancelDraw();
            return cancelAudio();
        };
    };
};
module.exports = {
    runEngine: runEngine,
    makeStrictMono: makeStrictMono,
    stepEngine: stepEngine
};
